import { OccConfig } from '@spartacus/core';

export const productInventoryOccConfig: OccConfig = {
  backend: {
    occ: {
      endpoints: {
        productInventory:
          '/users/${userId}/inventory/search?productCode=${productCode}&requestShippingDate=${requestShippingDate}',
      } as any,
    },
  },
};
